import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, of } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * AppNetworkService monitors the network connectivity status of the application.
 * It provides a reactive stream (`online$`) that emits the current online/offline status
 * based on browser events (`online`, `offline`) and the initial navigator state.
 * This service can be injected into components or other services to reactively respond
 * to changes in network connectivity.
 */
@Injectable({
  providedIn: 'root'
})
export class AppNetworkService {
  private _onlineSubject = new BehaviorSubject<boolean>(navigator.onLine);
  public online$ = this._onlineSubject.asObservable();

  constructor() {
    this.monitorNetwork();
  }

  private monitorNetwork() {
    const online$ = fromEvent(window, 'online').pipe(map(() => true));
    const offline$ = fromEvent(window, 'offline').pipe(map(() => false));

    merge(online$, offline$, of(navigator.onLine)).subscribe(status => {
      this._onlineSubject.next(status);
    });
  }
}

